import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RequestTypeEnum } from "src/app/utils/enums";
import { environment } from "src/environments/environment";
import { BaseApiService } from "../auth/base-api.service"
import { CloudServiceEnum } from "../cloud-storage/enums";
import { WolandCloudDriveAuthInfo } from "./base-drive.auth.service";

@Injectable({
    providedIn: 'root'
})
export class WolandCloudDriveServerConnectionService extends BaseApiService {
    private get baseUrl() {
        return environment.connectedApiUrls.woland + '/' + environment.apiVersions.woland;
    }

    constructor(public readonly http: HttpClient) {
        super(http);
    }

    public async requestToken(code: string, cloud: CloudServiceEnum, codeVerifier?: string): Promise<WolandCloudDriveAuthInfo> {
        console.log('requestToken() code: ' + code + ', cloud: ', cloud);
        const url = this.baseUrl + '/cloudConnection/requestToken';
        return this.post<WolandCloudDriveAuthInfo>(url, { code, cloud, codeVerifier }, undefined, RequestTypeEnum.WolandOneDriveRequestToken)
    }
}
